export const OTHER_INACTIVE = 'other_inactive'
